export default __webpack_public_path__ + "static/media/Highlord's Band of Slaughter.b6727027.jpg";